import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../../dux'
import CheckButton from './CheckButton/CheckButton'
import './CheckButtons.scss'

const CheckButtons = React.memo(({ question, type, options }) => {
  const value = useSelector(state => state.questions[question])
  const dispatch = useDispatch()
  const answerQuestion = ({ key, val }) => dispatch(actions.answerQuestion({ key, value: val }))
  const single = (key, val) => val !== value ? answerQuestion({ key, val }) : null
  const multiple = (key, val) => {
    if (value.includes(val)) {
      return answerQuestion({ key, val: value.filter(item => item !== val) })
    }
    return answerQuestion({ key, val: value.concat(val) })
  }
  const toggle = key => val => type === 'single' ? single(key, val) : multiple(key, val)

  return (
    <div className="check-buttons">
      {options.map((option, i) => (
        <Fragment key={i}>
          <div
            className="chck-btn-container"
          >
            <CheckButton
              checked={type === 'single' ? option.value === value : value.includes(option.value)}
              value={option.value}
              text={option.text}
              toggle={toggle(question)}
            />
          </div>
        </Fragment>
      ))}
    </div>
  )
})

CheckButtons.propTypes = {
  question: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    })
  ).isRequired
}

export default CheckButtons
